<template>
  <div class="g-form" v-show="rendered">
    <div class="text-formatted">
      <p>
        Принимаем оптовые заказы на саженцы роз, цветов многолетних, декоративные кустарники и деревья,
        клематисы и другие вьющиеся, растения на штамбе, хвойные, луковичные, плодовые растения, укорененные черенки,
        рассаду однолетних культур и семена.
      </p>
      <p></p>
    </div>
    <template v-if="send">
      <div class="messages messages--status">
        Спасибо!<br/>
        Мы ответим вам в ближайшее время.
      </div>
    </template>
    <template v-else>
      <div class="pretension-form">
        <div class="pretension-form-item">
          <div class="messages messages--error" v-if="message" v-html="message"></div>
          <h4>Получить прайс-листы</h4>
          <h5 class="form-required">Оставьте свои контактные данные, мы вышлем информацию в течение 1 часа</h5>
          <div class="pretension-form-row">
            <div class="form-wrapper">
              <label class="required" for="form-name">
                Имя
              </label>
              <input
                id="form-name"
                type="text"
                class="form-control required"
                v-model="fields.name"
                placeholder="Ваше имя"
                required
              />
              <span class="form-field-helper"></span>
            </div>

            <div class="form-wrapper">
              <label class="required" for="form-email">
                E-mail
              </label>
              <input
                id="form-email"
                type="email"
                class="form-control required"
                v-model="fields.email"
                placeholder="Ваш e-mail"
                required
              />
              <span class="form-field-helper"></span>
            </div>

            <div class="form-wrapper">
              <label for="form-phone">
                Телефон
              </label>
              <div class="g-form-field g-form-field--with-icon g-form-field--flags">
                <div
                  class="g-form-flag"
                  @click="togglePhoneDropdown()"
                  :class="{'g-form-flag--show': phoneDropdown.show}"
                >
                  <div class="g-form-flag-choosen" :class="'g-form-flag-choosen--' + phoneInput.country"></div>
                  <ul class="list">
                    <li
                      v-for="item in phoneDropdown.countryList"
                      @click="choseMask(item, true)"
                      :class="{'list-item--choosen': item.countryCode === phoneInput.country}"
                      class="list-item"
                    >
                      <img :src="'/themes/adaptive/images/icons/form-flag-' + item.countryCode + '.png'" alt="" />
                    </li>
                  </ul>
                </div>
                <div class="g-form-field-overlay">
                  <input
                    id="form-phone"
                    type="text"
                    class="form-control required"
                    v-model="fields.phone"
                    v-mask="phoneInput.mask"
                    @input="detectPhone"
                    placeholder="Ваш телефон"
                    required
                  />
                  <span class="form-field-helper"></span>
                  <div class="g-form-field-icon">
                    <svg class="g-form-field-icon-svg">
                      <use x="0" y="0" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-phone"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pretension-form-item pretension-form-item--submit">
        <div class="form-item form-type-checkbox form-item-fz152-agreement">
          <div class="cart-body-season-field">
            <input required type="checkbox" v-model="fields.agree" class="form-checkbox required">
            <div class="cart-body-season-field-overlay">
              <svg class="cart-body-season-field-overlay-icon">
                <use x="0" y="0" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#checked-icon"></use>
              </svg>
            </div>
          </div>
          <label class="option form-required">
            Даю согласие на обработку персональных данных
          </label>
          <div class="description">
            <a href="/policy" target="_blank">Политика обработки персональных данных</a>
          </div>
        </div>
        <div class="form-submit">
          <button
            type="button"
            class="btn-main btn-big btn-cart"
            :class="{'btn--is-loading': loading}"
            :disabled="loading"
            @click="submit"
          >
            <span class="btn-main-overlay">
              <span class="btn-main-content" v-if="loading">
                Создаём заявку
              </span>
              <span class="btn-main-content" v-else>
                Отправить
              </span>
            </span>
            <span class="btn-main-shadow"></span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PricelistsForm',
  data() {
    return {
      fields: {
        name: '',
        phone: '+7',
        email: '',
        agree: true,
      },
      phoneDropdown: {
        show: false,
        countryList: {
          ru: {
            countryCode: 'ru',
            mask: '+7 ### ###-##-##',
            validLength: 16
          },
          be: {
            countryCode: 'be',
            mask: '+375 ## ###-##-##',
            validLength: 17
          },
          kz: {
            countryCode: 'kz',
            mask: '+7 7## ###-##-##',
            validLength: 16
          }
        }
      },
      phoneInput: {
        country: 'ru',
        mask: '+7 ### ###-##-##',
        validLength: 16,
      },
      message: '',
      send: false,
      loading: false,
      rendered: false,
    }
  },
  methods: {
    submit() {
      this.message = '';

      if (!this.fields.name || !this.fields.email || !this.fields.phone || !this.fields.agree) {
        this.message = 'Не заполнены обязательные поля';
        return;
      }
      if (this.fields.email.indexOf('@') === -1 || this.fields.email.indexOf('.') === -1) {
        this.message = 'Поле E-mail заполнено не корректно';
        return;
      }
      if (this.fields.phone.length < this.phoneInput.validLength) {
        this.message = 'Поле Телефон заполнено не корректно';
        return;
      }

      this.createEntity();
    },
    createEntity() {
      this.loading = true;

      axios.post('/api/pricelists-request', this.fields).then(response => {
        if (response.data.success) {
          this.send = true;
        }
        else if (response.data.message) {
          this.message = response.data.message;
        }
      }).catch(() => {
        this.message = 'Произошла ошибка №1, пожалуйста, сообщите об ошибке на адрес zakaz@garshinka.ru.';
      }).finally(() => {
        this.loading = false;
      });
    },
    detectPhone() {
      let phone = this.fields.phone;

      if (!phone && this.phoneInput.country) {
        return;
      }

      phone = phone.replace(/\D/g, '');

      if (phone.startsWith('77')) {
        this.choseMask(this.phoneDropdown.countryList.kz);
      }
      else if (phone.startsWith('7')) {
        this.choseMask(this.phoneDropdown.countryList.ru);
      }
      else if (phone.startsWith('375')) {
        this.choseMask(this.phoneDropdown.countryList.be);
      }
      else {
        this.choseMask(this.phoneDropdown.countryList.ru);
      }
    },
    choseMask(item, clean = false) {
      this.phoneInput.validLength = item.validLength;
      this.phoneInput.country = item.countryCode;
      this.phoneInput.mask = item.mask;

      switch (item.countryCode) {
        case 'kz':
        case 'ru':
          if (this.fields.phone.length < 4 || clean) {
            this.fields.phone = '+7 ';
          }
          break;

        case 'be':
          if (this.fields.phone.length < 5 || clean || this.fields.phone === '+3 75') {
            this.fields.phone = '+375 ';
          }
          break;
      }

      if (!item || item.countryCode === 'ru') {
        if (this.fields.phone.includes('+8')) {
          this.fields.phone = '+7';
        }
        else if (this.fields.phone.includes('+9')) {
          this.fields.phone = '+7 9';
        }
      }
    },
    togglePhoneDropdown() {
      this.phoneDropdown.show = !this.phoneDropdown.show;
    },
  },
  created() {
    this.rendered = true;
    this.detectPhone();
  }
}
</script>
